export default __webpack_public_path__ + "static/media/AI.55f4e267.jpeg";